export function syncMenuSelectionToHoveredRow(
  root: ParentNode | null,
  indexAttribute: string,
  currentIndex: number | null,
  onSelectedIndexChange: (index: number) => void,
) {
  if (!root) {
    return;
  }

  const hovered = root.querySelector(`[${indexAttribute}]:hover`) as HTMLElement | null;
  const hoveredIndex = hovered?.getAttribute(indexAttribute);
  if (hoveredIndex == null) {
    return;
  }

  const next = Number(hoveredIndex);
  if (Number.isNaN(next) || next === currentIndex) {
    return;
  }

  onSelectedIndexChange(next);
}

/** Row currently under the pointer (CSS `:hover`), if any — useful when Enter fires before keyboard selection synced. */
export function getHoveredMenuRowIndex(root: ParentNode | null, indexAttribute: string): number | null {
  if (!root) return null;
  const hovered = root.querySelector(`[${indexAttribute}]:hover`) as HTMLElement | null;
  const raw = hovered?.getAttribute(indexAttribute);
  if (raw == null) return null;
  const next = Number(raw);
  return Number.isNaN(next) ? null : next;
}

export function getMenuSelectedIndex(
  root: ParentNode | null,
  indexAttribute: string,
  fallbackIndex: number,
) {
  if (!root) {
    return fallbackIndex;
  }

  const selected = root.querySelector(`[${indexAttribute}][aria-selected="true"]`) as HTMLElement | null;
  const selectedIndex = selected?.getAttribute(indexAttribute);
  if (selectedIndex == null) {
    return fallbackIndex;
  }

  const next = Number(selectedIndex);
  return Number.isNaN(next) ? fallbackIndex : next;
}
